import { TechRequestStatuses } from '@/types';

export const TECH_REQUEST_STATUSES = [
  { label: 'Выполнена', value: TechRequestStatuses.COMPLETED },
  { label: 'Не выполнена', value: TechRequestStatuses.NOT_COMPLETED },
  { label: 'Обрабатывается', value: TechRequestStatuses.PROCESSING },
  { label: 'Отклонена исполнителем', value: TechRequestStatuses.REJECTED_BY_EXECUTOR },
];
